import { useEffect, useRef } from "react";

export function usePrevious<T>(value: T): T {
  // this function will act as a "prevProps" for functional components
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current as T;
}
